// import { CheckIcon } from '@heroicons/react/outline'
import React, { useState, useEffect } from 'react'
import MonthlyToggle from './subcomponents/MonthlyToggle'
import EightyAnnual from './subcomponents/PricingDetails/EightyAnnual'
import EnterpriseToken from './subcomponents/PricingDetails/EnterpriseToken'
import FiftyMonthly from './subcomponents/PricingDetails/FiftyMonthly'
import FortyAnnual from './subcomponents/PricingDetails/FortyAnnual'
import HundredMonthly from './subcomponents/PricingDetails/HundredMonthly'
import TeamFiveHundred from './subcomponents/PricingDetails/TeamFiveHundred'
import TeamFourFiftyAnnual from './subcomponents/PricingDetails/TeamFourFiftyAnnual'
import TeamTwoFifty from './subcomponents/PricingDetails/TeamTwoFifty'
import TeamTwoTwentyAnnual from './subcomponents/PricingDetails/TeamTwoTwentyAnnual'
// import TeamToggle from './subcomponents/TeamToggle'

function PricingMain({
    auth,
    teamToken,
    subscriptions
}) {

    // console.log(subscriptions)

    const [ monthlyEnabled, setMonthlyEnabled ] = useState(false)
    // const [ teamEnabled, setTeamEnabled ] = useState(true)
    const teamEnabled= true
    const [ subType, setSubType ] = useState('')

    useEffect(() =>{
        if(teamToken?.[0]?.teamToken){
            setSubType("Team Plan")
        }
        else if(subscriptions?.[0]?.product?.id === 'prod_J8mOeYfobPCbDq'){
            setSubType("Individual Monthly 250 Messages")
        } else if(subscriptions?.[0]?.product?.id === 'prod_J2oNKQwYiFu6a1'){
            setSubType("Individual Monthly 500 Messages")
        } else if(subscriptions?.[0]?.product?.id === 'prod_JrFOqqiGdlX5K0'){
            setSubType("Individual Annual 250 Messages")
        } else if(subscriptions?.[0]?.product?.id === 'prod_JrFQCcm4mJFf5E'){
            setSubType("Individual Annual 600 Messages")
        } else if(subscriptions?.[0]?.product?.id === 'prod_JrFT0AjiDq6Va1'){
            setSubType("Team Monthly 1250 Messages")
        } else if(subscriptions?.[0]?.product?.id === 'prod_JrFUYOYziRkEYR'){
            setSubType("Team Monthly 2500 Messages")
        } else if(subscriptions?.[0]?.product?.id === 'prod_JrFRMAhvcDCKuK'){
            setSubType("Team Annual 1250 Messages")
        }else if(subscriptions?.[0]?.product?.id === 'prod_JrFSweJG4pb0WC'){
            setSubType("Team Annual 2500 Messages")
        }

    }, [subscriptions, setSubType, teamToken])

    return (
        <div>
            {subType !== "" ?
            <div className="mb-4">
                <span className="font-semibold text-base">Currently Subscribed to: </span><span className="bg-blue-600 text-white px-2 py-1 rounded-lg font-medium">{subType}</span>
            </div>
            : null }
            {/* The toggles for controlling pricing */}
            <div className='flex'>
            <div>
                <MonthlyToggle 
                enabled={monthlyEnabled}
                setEnabled={setMonthlyEnabled}
                />
            </div>
            {/* {teamToken?.[0]?.adminId === auth.uid ?
            <div className="ml-4">
                <TeamToggle 
                enabled={teamEnabled}
                setEnabled={setTeamEnabled}
                />
            </div>
            :
            null
            } */}
            </div>
            {/* Where all the pricing options will show up */}
            {monthlyEnabled ?
                (teamEnabled ?
                <div className="my-5">
                    <div>
                        <TeamTwoFifty 
                        auth={auth}
                        subscriptions={subscriptions}
                        />
                    </div>
                    <div className="mt-4">
                        <TeamFiveHundred 
                        auth={auth}
                        subscriptions={subscriptions}
                        />
                    </div>
                    <div className="mt-4">
                        <EnterpriseToken />
                    </div>
                </div>
                :
                <div className="my-5">
                    <div>
                    <FiftyMonthly 
                    auth={auth}
                    subscriptions={subscriptions}
                    />
                    </div>
                    <div className="mt-4">
                    <HundredMonthly 
                    auth={auth}
                    subscriptions={subscriptions}
                    />
                    </div>
                </div>
                )
            :
                (teamEnabled ?
                <div className="my-5">
                    <div>
                        <TeamTwoTwentyAnnual 
                        auth={auth}
                        subscriptions={subscriptions}
                        />
                    </div>
                    <div className="mt-4">
                        <TeamFourFiftyAnnual 
                        auth={auth}
                        subscriptions={subscriptions}
                        />
                    </div>
                    <div className="mt-4">
                        <EnterpriseToken />
                    </div>
                </div>
                :
                <div className="my-5">
                    {/* Forty Annual */}
                    <div>
                    <FortyAnnual 
                    auth={auth}
                    subscriptions={subscriptions}
                    />
                    </div>
                    <div className="mt-4">
                    <EightyAnnual 
                    auth={auth}
                    subscriptions={subscriptions}
                    />
                    </div>
                </div>
                )
            }
            
        </div>
    )
}

export default PricingMain
